/**
 * Environment variables configuration
 * All environment variables must be prefixed with VITE_ to be exposed to the client
 */
import { Capacitor } from '@capacitor/core'

// On Android emulator, localhost points to the emulator itself.
// 10.0.2.2 is the special alias for the host machine.
function getApiUrl(): string {
  const url = import.meta.env.VITE_API_URL || 'http://localhost:8000/api'
  if (Capacitor.getPlatform() === 'android') {
    return url.replace('localhost', '10.0.2.2')
  }
  return url
}

export const env = {
  // API Configuration
  api: {
    url: getApiUrl(),
    timeout: Number(import.meta.env.VITE_API_TIMEOUT) || 10000,
  },

  // Public website (Laravel web pages: terms, tutorials, ...)
  web: {
    url: getApiUrl().replace(/\/api\/?$/, ''),
  },

  // Firebase Configuration
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || '',
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || '',
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || '',
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || '',
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
    appId: import.meta.env.VITE_FIREBASE_APP_ID || '',
    vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY || '',
  },

  // Pusher / WebSocket
  pusher: {
    key: import.meta.env.VITE_PUSHER_APP_KEY || '',
    cluster: import.meta.env.VITE_PUSHER_CLUSTER || 'eu',
    host: import.meta.env.VITE_PUSHER_HOST || '',
    port: Number(import.meta.env.VITE_PUSHER_PORT) || 443,
    scheme: import.meta.env.VITE_PUSHER_SCHEME || 'https',
  },

  // App Info
  app: {
    name: import.meta.env.VITE_APP_NAME || 'sportovo.io',
    version: import.meta.env.VITE_APP_VERSION || '1.0.0',
  },

  // Environment
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
  mode: import.meta.env.MODE,
}

export default env
